// Turns an enum key like "FieldService" into a display name like "Field Service"
export const prettifyEnumName = (name: string) => name.replace(/([a-z])([A-Z])/g, '$1 $2');
